import useSWR from 'swr'

import { fetchWithToken } from 'services/fetchers'

import * as T from 'types'

import getErrorMessage from '../utils/getErrorMessage'
import { isServerError } from '../utils/isServerError'

// This is the order that corresponds to the currently viewed listing which contains the
// pricing package selected by the user
export const useListingPricingPackageOrder = (listing?: T.IListing) => {
  const key = listing ? `/orders/listing/${listing._id}/pricingPackage` : null
  const response = useSWR<T.IOrderUnpopulated | T.IServerError>(key, fetchWithToken)

  let listingPricingPackage: T.IOrderUnpopulated | undefined

  if (response.data && !isServerError(response.data) && Object.keys(response.data).length !== 0) {
    listingPricingPackage = response.data
  }

  const error = getErrorMessage(response, 'pricing package order')

  return { ...response, listingPricingPackage, error }
}
